module.exports = __webpack_public_path__ + "static/media/logo.07aa31c9.png";